import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';
import { PageSeo } from 'src/components/page-seo';
import { PageHero } from 'src/components/page-hero';

export function PrivacyView() {
  const { t } = useTranslation('privacy');
  const { t: tCommon } = useTranslation('common');

  const sections = t('sections', { returnObjects: true });

  return (
    <>
      <PageSeo path={paths.privacy} title={t('meta.title')} description={t('meta.description')} />

      <PageHero
        lead={t('hero.lead')}
        title={t('hero.title')}
        current={t('hero.breadcrumb')}
        links={[{ to: paths.home, label: tCommon('labels.home') }]}
      />

      <section className="section tight-top">
        <div className="container narrow prose">
          {sections.map((section) => (
            <Fragment key={section.title}>
              <h2>{section.title}</h2>
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </Fragment>
          ))}
        </div>
      </section>
    </>
  );
}
